export default __webpack_public_path__ + "static/media/helper.77a8229b.png";